import request from '@/utils/request'

const http = request()

export const getAllMenus = () => http.post('/system/menu/all')

export const getRoutes = () => http.post('/system/menu/routes')
